import { createContext } from "react";
export const  RootContext = createContext({});
export const  RootProvider=RootContext.Provider;